import produce from "immer";
import { create } from "zustand";
import * as api from "../services/settings";

export const useSqlbaseStore = create((set) => ({
  config: null,
  natrav: null,
  authorization: null,
  hasExisting: false,

  fetchConfig: async () => {
    const { data, error } = await api.getSqlbase();
    if (data) {
      const filled = Object.values(data).some((v) => v !== "");
      set(
        produce((draft) => {
          draft.config = data;
          draft.hasExisting = filled;
        }),
      );
    }
    return { data, error };
  },

  updateConfig: async (payload) => {
    const { data, error } = await api.updateSqlbase(payload);
    if (data) {
      const filled = Object.values(data).some((v) => v !== "");
      set(
        produce((draft) => {
          draft.config = data;
          draft.hasExisting = filled;
        }),
      );
    }
    return { data, error };
  },

  clearConfig: async () => {
    const emptyValues = { db_name: "", username: "", password: "" };
    const { data, error } = await api.updateSqlbase(emptyValues);
    if (!error) {
      set(
        produce((draft) => {
          draft.config = emptyValues;
          draft.hasExisting = false;
        }),
      );
    }
    return { data, error };
  },

  checkConnection: async (payload) => {
    return await api.checkSqlbase(payload);
  },

  fetchNatrav: async () => {
    const { data, error } = await api.getNatrav();
    if (data) {
      set(
        produce((draft) => {
          draft.natrav = data;
        }),
      );
    }
    return { data, error };
  },

  checkTunnel: async () => {
    return await api.checkTunnel();
  },

  fetchAuthorization: async () => {
    const { data, error } = await api.getSqlbaseAuthorization();
    if (data) {
      set(
        produce((draft) => {
          draft.authorization = data;
        }),
      );
    }
    return { data, error };
  },

  acceptAuthorization: async ({ dbName } = {}) => {
    const { data, error } = await api.acceptSqlbaseAuthorization({ dbName });
    if (data) {
      set(
        produce((draft) => {
          draft.authorization = data;
        }),
      );
    }
    return { data, error };
  },
}));
